import "./App.css";
import Navbar from "./components/header/Navbar";
import Maincomponent from "./components/home/Maincomponent";
import { Routes, Route } from "react-router-dom";
import Sign_in from "./components/signup_signin/Sign_in";
import Sign_up from "./components/signup_signin/Sign_up";
import Cart from "./components/cart/Cart";
import Buynow from "./components/buynow/Buynow";
import FestivalLaunches from "./components/FestivalLaunchesPage/FestivalLaunches";
import Personalinfo from "./components/dashbord/Dashbord";
import AdminDeshboard from "./components/Admin/DisplayDeshboard/AdminDeshboard";
import AdminSidebar from "./components/Admin/AdminSidebar";
import AdminItemList from "./components/Admin/AdminProductList/AdminItemList";
import AdminRecentOrders from "./components/Admin/AllOrders/AllOrders";
import AdminAdd from "./components/Admin/AdminAdd/AdminAdd";
import { MyContextSupply } from "./Context";
import CircularProgress from "@mui/material/CircularProgress";
import FourZeroFour from "./components/FourZeroFour";
import AddPopUp from "./components/ProductAddPopUp/AddPopUp";
import { ToastContainer } from "react-toastify";
import { useEffect, useState } from "react";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  const {
    token,
    isAdmin,
    path,
    isProductAddPopUpOpen,
    setIsProductAddPopUpOpen,
    singleProductPathId,
    cartItems,
    adminValidation,
  } = MyContextSupply();
  const [data, setData] = useState(false);

  // console.log(path)

  useEffect(() => {
    if (
      path === "/" ||
      (path === `/getproductsone/${singleProductPathId}` &&
        path === "/festival/launches/products" &&
        cartItems.length !== 0)
    ) {
      if (isProductAddPopUpOpen) {
        setIsProductAddPopUpOpen(true);
      }
    } else {
      setIsProductAddPopUpOpen(false);
    }
  }, [path]);

  // console.log(typeof isAdmin);
  // console.log(isAdmin);

  useEffect(() => {
    const tim = setTimeout(() => {
      setData(true);
    }, 2000);
    return () => {
      clearTimeout(tim);
    };
  }, []);
  return (
    <>
      {data ? (
        <div className="all-component-inside">
          <AddPopUp />
          {/* <Newnev /> */}
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <Navbar />
                  <Maincomponent />
                </>
              }
            />
            <Route
              path="/login"
              element={
                <>
                  <Navbar />
                  <Sign_in />
                </>
              }
            />
            <Route
              path="/register"
              element={
                <>
                  <Navbar />
                  <Sign_up />
                </>
              }
            />
            <Route
              path="/festival/launches/products"
              element={
                <>
                  <Navbar />
                  <FestivalLaunches />
                </>
              }
            />
            <Route
              path="/getproductsone/:id"
              element={
                <>
                  <Navbar />
                  <Cart />
                </>
              }
            />
            <Route
              path="/buynow"
              element={
                <>
                  <Navbar />
                  <Buynow />
                </>
              }
            />
            {token.length !== 0 &&
              isAdmin &&
              adminValidation !== undefined &&
              adminValidation !== null &&
              adminValidation === "verified" && (
                <>
                  <Route
                    path="/admin"
                    element={
                      <>
                        <AdminSidebar />
                        <AdminDeshboard />
                      </>
                    }
                  />
                  <Route
                    path="/add/product"
                    element={
                      <>
                        <AdminSidebar />
                        <AdminAdd />
                      </>
                    }
                  />
                  <Route
                    path="/product/list"
                    element={
                      <>
                        <AdminSidebar />
                        <AdminItemList />
                      </>
                    }
                  />
                  <Route
                    path="/recent/orders"
                    element={
                      <>
                        <AdminSidebar />
                        <AdminRecentOrders />
                      </>
                    }
                  />
                </>
              )}
            {token.length !== 0 ? (
              <Route
                path="/personalinfo"
                element={
                  <>
                    <Navbar />
                    <Personalinfo />
                  </>
                }
              />
            ) : (
              <Route
                path="/login"
                element={
                  <>
                    <Navbar />
                    <Sign_in />
                  </>
                }
              />
            )}
            <Route path="*" element={<FourZeroFour />} />
          </Routes>
          <ScrollToTop />
        </div>
      ) : (
        <div className="circle">
          <CircularProgress />
          <h2>Loading</h2>
        </div>
      )}
      <ToastContainer className="react-toastify-zindex" />
    </>
  );
}

export default App;
